module.exports = __webpack_public_path__ + "img/Juliette-van-Rhyn-website.911622c6.jpeg";